// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__lW6Ir","colBig":"styles_colBig__1RjMT","colSmall":"styles_colSmall__2xUJS"};